import i18n from 'helpers/i18n';
import messages from './messages';

interface IncompleteDimensionsProps {
  completeCodesError: boolean;
  /** Comma-separated "Name (Abbreviation)" list of dimensions still missing a code */
  missingDimensionsList?: string;
}

function IncompleteDimensions({
  completeCodesError,
  missingDimensionsList
}: IncompleteDimensionsProps) {
  if (!completeCodesError) {
    return null;
  }

  const errorMessage = missingDimensionsList
    ? i18n.ft(messages.missingDimensionsError, {
        dimensions: missingDimensionsList
      })
    : i18n.ft(messages.incompleteDimensionsError);

  return (
    <span role="alert" className="text-ds-text-negative text-center">
      {errorMessage}
    </span>
  );
}

export default IncompleteDimensions;
